import adminAPIs from "apis/AdminApis";
import useUploadImage from "hooks/imageContext";
import { useEffect, useState } from "react";
const base_URL = process.env.REACT_APP_API_BASE_URL;

function ManageEvent() {
  const [events, setEvents] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingEvent, setEditingEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [uploadedImages, setUploadedImages] = useState([]);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const { uploadImage, loading: uploading, data: imageData } = useUploadImage();


  const [formData, setFormData] = useState({
      ev_name: "",
      venue: "",
    description: "",
    attachments: "",
    timing: "",
    isVisible: true,
  });

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    setLoading(true);
    try {
      const data = await adminAPIs.allEvents();

      console.log(data?.data?.data);
      setEvents(data?.data?.data || []);
    } catch (err) {
      setError("Failed to load events");
    } finally {
      setLoading(false);
    }
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files;
    if (file) {
      try {
        const data = await uploadImage(file, "Feeds");
        console.log(data);
        const images = uploadedImages ? [...uploadedImages, ...data?.data] : [data?.data];

        setUploadedImages(images);
        setFormData((prev) => ({ ...prev, attachments: [...data?.data, ...uploadedImages] }));
      } catch (err) {
        console.log(err);
        setError("Failed to upload image");
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    console.log(formData);
    try {
      const eventRes = await adminAPIs.upsertEvent(formData);
      console.log(eventRes);
      if (editingEvent) {
        setEvents((prev) =>
          prev.map((feed) => (feed.id === editingEvent.id ? { ...feed, ...formData } : feed))
        );
      } else {
        setEvents((prev) => [...prev, { ...formData, id: Date.now() }]);
      }
      fetchEvents();
      setSuccess("Event successfully saved!");
      setIsModalOpen(false);
      resetForm();
    } catch (err) {
      console.log(err);
      setError("Failed to save feed");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (feed) => {
    console.log(feed);
    setFormData(feed);
    setUploadedImages([...feed?.attachments]);
    setIsModalOpen(true);
  };

  const resetForm = () => {
    setFormData({
      ev_name: "",
      description: "",
      attachments: "",
      timing: "",
      isVisible: true,
    });
    setEditingEvent(null);
    setUploadedImages([]);
  };



  const handleDelete = async (feedId) => {
    if (confirm("Are you sure you want to delete this event? This action cannot be undone.")) {
      setLoading(true);
      try {
        await adminAPIs.deleteEvent(feedId);
        await fetchEvents();
        setSuccess("Event successfully deleted!");
      } catch (err) {
        console.log(err);
        setError("Failed to delete feed");
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 font-inter">Alumni Event Management</h1>
          <p className="mt-2 text-gray-600">Create and manage updates for the alumni community</p>
        </div>
        <button
          onClick={() => setIsModalOpen(true)}
          className="bg-gradient-to-r from-[#D4AF37] to-[#C5A028] text-white px-6 py-3 rounded-lg
                       font-medium transition-all duration-300 flex items-center gap-2 hover:from-[#C5A028] hover:to-[#B69020]"
        >
          <i className="fas fa-plus"></i>
          Create New Event
        </button>
      </div>

      {error && (
        <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg text-red-600">
          <i className="fas fa-exclamation-circle mr-2"></i>
          {error}
        </div>
      )}

      {success && (
        <div className="mb-4 p-4 bg-green-50 border border-green-200 rounded-lg text-green-600">
          <i className="fas fa-check-circle mr-2"></i>
          {success}
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {loading
          ? [...Array.from({ length: 6 })].map((_, i) => (
              <div key={i} className="bg-white rounded-xl shadow-md p-4 animate-pulse">
                <div className="w-full h-48 bg-gray-200 rounded-lg mb-4"></div>
                <div className="h-6 bg-gray-200 rounded w-3/4 mb-2"></div>
                <div className="h-4 bg-gray-200 rounded w-1/2 mb-4"></div>
                <div className="flex justify-between items-center">
                  <div className="h-8 bg-gray-200 rounded w-24"></div>
                  <div className="h-8 bg-gray-200 rounded w-24"></div>
                </div>
              </div>
            ))
          : events.map((feed) => (
              <div
                key={feed.id}
                className="bg-white rounded-xl shadow-md hover:shadow-lg transition-all duration-300"
              >
                <img
                  src={base_URL + "/get-image?objectKey=" + feed.attachments[0]}
                  alt={feed.ev_name}
                  className="w-full h-48 object-cover rounded-t-xl"
                />
                <div className="p-4">
                  <div className="flex items-center gap-2 mb-2">

                    <span className="text-gray-500 text-sm">
                      {new Date(feed.timing).toLocaleDateString()}
                    </span>
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">{feed.ev_name}</h3>
                  <p className="text-gray-600 text-sm line-clamp-2 mb-4">{feed.description}</p>
                  <div className="flex justify-between items-center">
                    <button
                      onClick={() => handleEdit(feed)}
                      className="text-blue-600 hover:text-blue-700 transition-colors duration-200"
                    >
                      <i className="fas fa-edit mr-1"></i>
                      Edit
                    </button>

                    <button
                      onClick={() => handleDelete(feed.id)}
                      className="text-red-600 hover:text-red-700 transition-colors duration-200"
                    >
                      <i className="fas fa-trash-alt mr-1"></i>
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            ))}
      </div>

      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-xl p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-semibold text-gray-900">
                {editingEvent ? "Edit Event" : "Create New Event"}
              </h2>
              <button
                onClick={() => {
                  setIsModalOpen(false);
                  resetForm();
                }}
                className="text-gray-500 hover:text-gray-700"
              >
                <i className="fas fa-times"></i>
              </button>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-gray-700 font-medium mb-2">Title</label>
                <input
                  type="text"
                  required
                  value={formData.ev_name}
                  onChange={(e) => setFormData((prev) => ({ ...prev, ev_name: e.target.value }))}
                  className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-[#D4AF37] focus:outline-none"
                  placeholder="Enter event name"
                />
                          </div>
                          <div>
                <label className="block text-gray-700 font-medium mb-2">Venue</label>
                <input
                  type="text"
                  required
                  value={formData.venue}
                  onChange={(e) => setFormData((prev) => ({ ...prev, venue: e.target.value }))}
                  className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-[#D4AF37] focus:outline-none"
                  placeholder="Enter venue"
                />
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-2">Description</label>
                <textarea
                  required
                  value={formData.description}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      description: e.target.value,
                    }))
                  }
                  className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-[#D4AF37] focus:outline-none h-32"
                  placeholder="Enter agends"
                ></textarea>
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-2">Image</label>
                <div className="flex items-center gap-4">
                  <input
                    type="file"
                    multiple
                    accept="image/*"
                    onChange={handleImageUpload}
                    className="hidden"
                    id="image-upload"
                  />
                  <label
                    htmlFor="image-upload"
                    className="px-4 py-2 bg-blue-50 text-blue-600 rounded-lg cursor-pointer hover:bg-blue-100 transition-colors duration-200"
                  >
                    <i className="fas fa-upload mr-2"></i>
                    Choose files
                  </label>
                  {uploadedImages.length > 0 && (
                    <div className="flex items-center gap-2">
                      {uploadedImages.map((image, index) => (
                        <img
                          key={index}
                          src={`${base_URL}/get-image?objectKey=${image}`}
                          alt={`Uploaded Image ${index + 1}`}
                          className="h-20 w-20 object-cover rounded-lg"
                        />
                      ))}
                    </div>
                  )}
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-gray-700 font-medium mb-2">Date & Time</label>
                  <input
                    type="datetime-local"
                    required
                    value={formData.timing ? new Date(formData.timing).toISOString().slice(0, 16):null}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        timing: e.target.value,
                      }))
                    }
                    className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-[#D4AF37] focus:outline-none"
                  />
                </div>


              </div>

              <div className="flex justify-end gap-4 mt-8">
                <button
                  type="button"
                  onClick={() => {
                    setIsModalOpen(false);
                    resetForm();
                  }}
                  className="px-6 py-3 bg-gray-50 text-gray-600 rounded-lg font-medium hover:bg-gray-100 transition-colors duration-200"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="px-6 py-3 bg-gradient-to-r from-[#D4AF37] to-[#C5A028] text-white rounded-lg font-medium hover:from-[#C5A028] hover:to-[#B69020] transition-all duration-300 flex items-center gap-2"
                >
                  {loading ? (
                    <>
                      <i className="fas fa-circle-notch fa-spin"></i>
                      {editingEvent ? "Updating..." : "Creating..."}
                    </>
                  ) : (
                    <>
                      <i className="fas fa-save"></i>
                      {editingEvent ? "Update Event" : "Create Event"}
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default ManageEvent;
